import React from 'react';
import { motion } from 'framer-motion';
import { useShop } from '../../context/ShopContext';

const Hero = () => {
  const { setIsRegistryOpen } = useShop();

  return (
    <section className="relative min-h-[100vh] lg:h-[100vh] flex items-center overflow-hidden pt-20">
      <div className="absolute inset-0 z-0">
        <div className="grid grid-cols-12 h-full">
          <div className="col-span-12 lg:col-span-8 relative">
            <img 
              src="https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?auto=format&fit=crop&q=80&w=2000" 
              alt="Peaceful nursery" 
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/5"></div>
          </div>
          <div className="hidden lg:block lg:col-span-4 bg-luma-bg"></div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full">
        <div className="max-w-2xl lg:max-w-xl bg-luma-bg/80 lg:bg-transparent backdrop-blur-md lg:backdrop-blur-none p-8 md:p-12 lg:p-0 rounded-3xl">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          >
            <span className="text-luma-primary text-[10px] md:text-xs font-bold tracking-[0.3em] uppercase mb-6 block">
              Curating Your First Chapter
            </span>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] text-luma-text mb-8">
              Tender <br/> <span className="italic">beginnings</span> <br/> start here.
            </h1>
            <p className="text-base md:text-lg text-luma-text/70 mb-10 font-light leading-relaxed max-w-md">
              Discover a serene collection of nursery essentials and registry must-haves, designed with safety and softness at the heart of every detail.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-5">
              <button 
                onClick={() => setIsRegistryOpen(true)}
                className="bg-luma-primary text-white px-10 py-5 rounded-full text-xs font-bold tracking-widest uppercase hover:bg-luma-text transition-all duration-300 shadow-xl shadow-luma-primary/10"
              >
                Start Registry
              </button>
              <button 
                className="bg-white text-luma-text border border-luma-sand/50 px-10 py-5 rounded-full text-xs font-bold tracking-widest uppercase hover:border-luma-primary transition-all duration-300"
              >
                Shop Essentials
              </button>
            </div>
          </motion.div>
        </div>
      </div>

      <motion.div 
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 hidden lg:flex flex-col items-center gap-4"
      >
        <span className="text-[9px] uppercase tracking-[0.3em] opacity-40 font-bold rotate-90 origin-left translate-x-2">Scroll</span>
        <div className="w-[1px] h-12 bg-luma-text/20"></div>
      </motion.div>
    </section>
  );
};

export default Hero;